import { render, staticRenderFns } from "./ListApiTokens.vue?vue&type=template&id=16957952"
import script from "./ListApiTokens.vue?vue&type=script&lang=js"
export * from "./ListApiTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports